import React from 'react';
import PropTypes from 'prop-types';

class GoogleSelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      searchValue: null,
      searchResults: [],
    };

    this.places = null;
    this.lastSelected = '';
  }

  componentDidUpdate() {
    if (!this.places && window.google) {
      this.places = $$initService();
    }

    if (this.state.searchValue === null && this.props.defaultItem) {
      this.lastSelected = this.props.defaultItem;
      this.setState({ searchValue: this.props.defaultItem });
    }

    if (!this.state.isOpen && this.state.searchValue !== this.props.defaultItem) {
      this.lastSelected = this.props.defaultItem;
      this.setState({ searchValue: this.props.defaultItem });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.closeDropDown);
  }

  getDropDownList = () => {
    const { searchResults } = this.state;
    const { itemClassName } = this.props;

    return searchResults.map((element, index) => (
      <div
        key={index}
        className={`select__drop-down-item select__drop-down-item_primary ${itemClassName}`}
        onClick={this.handleSelect(element)}
      >
        {element}
      </div>
    ));
  };

  openDropDown = event => {
    if (!this.state.isOpen) {
      document.addEventListener('click', this.closeDropDown);
      this.setState({ isOpen: true });
    } else {
      event.nativeEvent.stopImmediatePropagation();
    }
  };

  closeDropDown = () => {
    if (this.state.isOpen) {
      document.removeEventListener('click', this.closeDropDown);
    }

    this.setState({ isOpen: false, searchValue: this.lastSelected });
  };

  handleInputChange = ({ target }) => {
    this.setState({ searchValue: target.value }, () => {
      if (this.places && target.value) {
        this.places.getPlacePredictions(
          {
            input: target.value,
            types: ['(cities)'],
          },
          predictions => {
            const searchResults = [];

            if (predictions) {
              predictions.forEach(prediction => searchResults.push(prediction.description));
            }

            this.setState({ searchResults });
          }
        );
      }
    });
  };

  handleSelect = searchValue => event => {
    event.stopPropagation();
    event.nativeEvent.stopPropagation();

    this.lastSelected = searchValue;
    this.setState({ searchValue }, () => this.props.handleSelect(searchValue));
  };

  handleClearInputClick = event => {
    const { searchValue } = this.state;
    const { defaultItem, handleSelect } = this.props;

    if (searchValue || defaultItem) {
      event.stopPropagation();
      if (event.nativeEvent) event.nativeEvent.stopImmediatePropagation();

      this.setState({ searchValue: '' }, () => {
        if (defaultItem) handleSelect('', event);
      });
    }
  };

  render() {
    const { isOpen, searchValue } = this.state;
    const {
      label,
      placeholder,
      error,
      capitalizeLabel,
      disabled,
      inputClassName,
      dropDownClassName,
      inputFieldWrapperClassName,
      mainWrapperClassName,
      labelClassName,
      tabIndex,
    } = this.props;

    const updatedLabel = label && capitalizeLabel ? label[0].toUpperCase() + label.slice(1).toLowerCase() : label;
    const errorTextElement = error ? <div className='ect-select-error'>{error}</div> : null;

    const isOpenClass = isOpen ? 'open' : '';
    const errorClass = `${error ? 'error' : ''}`;

    const mainWrapperClasses = `select__main-wrapper select__main-wrapper_primary
    ${errorClass} ${mainWrapperClassName}`;
    const labelClasses = `select__label select__label_primary ${labelClassName}`;
    const inputFieldWrapperClasses = `select__input-field-wrapper
    select__input-field-wrapper_primary ${inputFieldWrapperClassName}`;
    // const loadPlaceholderClasses = `select__loading-placeholder select__loading-placeholder_primary ${inputClassName}`;
    const inputFieldClasses = `select__input select__input_primary
                   ${inputClassName} ${disabled ? 'select__input_primary_disabled' : ''} ${isOpenClass} ${errorClass}`;
    const inputFieldIconClasses = `select__clear-input-icon select__clear-input-icon_primary
              ${searchValue ? 'select__clear-input-icon_primary_clear-mode' : ''}`;
    const dropDownListClasses = `select__drop-down-list select__drop-down-list_primary
    ${isOpenClass} ${dropDownClassName}`;

    return (
      <div className={mainWrapperClasses}>
        <label className={labelClasses}>{updatedLabel}</label>

        <div className={inputFieldWrapperClasses}>
          <input
            value={searchValue}
            className={inputFieldClasses}
            placeholder={placeholder}
            disabled={disabled}
            onChange={this.handleInputChange}
            tabIndex={tabIndex}
            onFocus={this.openDropDown}
            onClick={this.openDropDown}
          />
          <div className={inputFieldIconClasses} onClick={this.handleClearInputClick} />
          {errorTextElement}
        </div>

        <div className={dropDownListClasses}>{this.getDropDownList()}</div>
      </div>
    );
  }
}

GoogleSelect.propTypes = {
  defaultItem: PropTypes.string,
  handleSelect: PropTypes.func.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]),
  capitalizeLabel: PropTypes.bool,
  disabled: PropTypes.bool,
  inputClassName: PropTypes.string,
  dropDownClassName: PropTypes.string,
  mainWrapperClassName: PropTypes.string,
  inputFieldWrapperClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  itemClassName: PropTypes.string,
  tabIndex: PropTypes.number
};

GoogleSelect.defaultProps = {
  defaultItem: '',
  handleSelect: () => {},
  label: '',
  placeholder: '',
  error: '',
  capitalizeLabel: false,
  disabled: false,
  inputClassName: '',
  dropDownClassName: '',
  mainWrapperClassName: '',
  inputFieldWrapperClassName:'',
  labelClassName: '',
  itemClassName: '',
  tabIndex: 0
};

export default GoogleSelect;

function $$initService() {
  if (window.google) {
    return new window.google.maps.places.AutocompleteService();
  } else {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/app/Components/GoogleSelect.jsx